import { checkValidFieldByFeatureType } from '../WidgetSettingPanel/utils';
import { FEATURE_TYPES } from '../WidgetSettingPanel/const';

export const getPrefix = R.ifElse(
    R.test(/:/),
    R.compose(R.head, R.split(':')),
    R.always('basic')
);

export const makeBreakdownListByCategory = R.compose(
    R.map(R.pluck('name')),
    R.groupBy(
        ({ category, alternativeChannelName }) =>
            alternativeChannelName || category
    )
);

export const makeCategoryListByPrefix = R.reduce(
    (acc, [category, breakdownList]) => {
        const prefix = R.compose(getPrefix, R.head)(breakdownList);

        return R.over(
            R.lensProp(prefix),
            R.compose(R.append(category), R.defaultTo([])),
            acc
        );
    },
    {}
);

export const makeCategoryLocaleMap = R.reduce(
    (acc, { name, locale }) => R.assoc(name, locale, acc),
    {}
);

export const checkValidFilterField = checkValidFieldByFeatureType(
    FEATURE_TYPES.FILTERS
);
